// extracted by mini-css-extract-plugin
module.exports = {"componentStyle":"ScrollImageModal_componentStyle__DVOlb","contentsContainer":"ScrollImageModal_contentsContainer__QY0hZ","navButton":"ScrollImageModal_navButton__jTAyV"};